export default __webpack_public_path__ + "static/media/team105.7de7c1fb.JPG";